import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: process.env.REACT_APP_OIDC_AUTH_URL!,
    clientId: process.env.REACT_APP_OIDC_CLIENT_ID!,
    realm: process.env.REACT_APP_OIDC_REALM!,
});

export default keycloak;